import {AxiosError} from "axios";

export default function handleAxiosError(axiosError: AxiosError) {

  let errorMessage: string = ""
  let validationMessages: Record<string, string> = {}

  const connectionError = axiosError.code == "ERR_NETWORK" || axiosError.response?.status == -1
  if (connectionError) {
    errorMessage = "Forbindelsesfejl."
  } else if (axiosError.code == "ERR_CANCELED") {
    errorMessage = "Annulleret."
  } else if (axiosError?.message?.indexOf("timeout") >= 0) {
    errorMessage = "Timeout."
  } else if (axiosError.response?.status == 500) {
    errorMessage = "Serverfejl (500)."
  } else if (axiosError.response?.status == 404) {
    // since the API is generated, paths should always work, we must investigate why this is happening
    errorMessage = "Data kunne ikke findes (404)."
  } else if (axiosError.response?.status == 403) {
    // we let our client call a resource which it should not have access to
    errorMessage = "Adgangsfejl (403)."
  } else if (axiosError.response?.status == 401) {
    errorMessage = "Adgangsfejl (401)."
  } else {

    // @ts-ignore
    validationMessages = axiosError.response?.data?.validationMessages ?? null
    if (validationMessages != null) {
      errorMessage = "Valideringsfejl."
    } else {
      errorMessage = "Ukendt fejl."
    }
  }
  return {
    errorMessage,
    validationMessages
  }

}